export default __webpack_public_path__ + "static/0278-7ffe8ec5e2b77f4b0eb0835d9410a3dd.png";